class SocialEngagementService {
  constructor() {
    if (typeof window !== 'undefined') {
      const origin = window.location.origin;
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      this.baseUrl = process.env.REACT_APP_API_URL || (isLocalhost ? 'https://api.rainbow-sails.shop:3443' : origin);
    } else {
      this.baseUrl = process.env.REACT_APP_API_URL || 'https://api.rainbow-sails.shop:3443';
    }
  }

  get apiRoot() {
    return `${this.baseUrl}/api/social`;
  }

  async getEngagement(contentId) {
    const response = await fetch(`${this.apiRoot}/${encodeURIComponent(contentId)}/engagement`, {
      credentials: 'include'
    });

    if (response.status === 404) {
      return {
        success: true,
        contentId,
        likes: 0,
        likedBy: [],
        comments: []
      };
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch engagement for ${contentId}`);
    }
    return response.json();
  }

  async likeContent(contentId, like = true, user) {
    if (!user || !user.id) {
      throw new Error('User authentication required to like content');
    }

    const response = await fetch(`${this.apiRoot}/${encodeURIComponent(contentId)}/like`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
        like,
        userId: user.id,
        userName: [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email || 'Zee Fan'
      })
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || `Failed to update like for ${contentId}`);
    }
    return response.json();
  }

  async addComment(contentId, comment, user) {
    if (!user || !user.id) {
      throw new Error('User authentication required to comment');
    }

    const response = await fetch(`${this.apiRoot}/${encodeURIComponent(contentId)}/comments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
        ...comment,
        userId: user.id,
        name: comment.name || [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email || 'Zee Fan'
      })
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || `Failed to add comment for ${contentId}`);
    }

    return response.json();
  }
}

const socialEngagementService = new SocialEngagementService();
export default socialEngagementService;

